import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './PublicHomePage.css';

const PublicHomePage: React.FC = () => {
  return (
    <div className="public-home">
      <header className="public-home-header">
        <div className="public-home-header-inner">
          <Link to="/home" className="public-home-brand" aria-label="Mends home">
            <img src={logo} alt="" className="public-home-logo" />
            <span>Mends</span>
          </Link>
          <nav className="public-home-nav" aria-label="Primary">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/" className="public-home-nav-cta">
              Sign in
            </Link>
          </nav>
        </div>
      </header>

      <main className="public-home-main">
        <section className="public-home-hero">
          <p className="public-home-eyebrow">AI-powered CRM &amp; conversations</p>
          <h1>Conversations that close.</h1>
          <p className="public-home-lead">
            Mends is a business platform that helps teams manage WhatsApp and other customer
            conversations, CRM pipelines, scheduling, and AI-assisted follow-ups — so leads and
            customers stay organized in one place.
          </p>
          <div className="public-home-actions">
            <Link to="/" className="public-home-btn public-home-btn-primary">
              Sign in to Mends
            </Link>
            <Link to="/privacy" className="public-home-btn public-home-btn-ghost">
              Privacy Policy
            </Link>
            <Link to="/terms" className="public-home-btn public-home-btn-ghost">
              Terms of Service
            </Link>
          </div>
        </section>

        <section className="public-home-section" aria-labelledby="what-mends-does">
          <h2 id="what-mends-does">What Mends does</h2>
          <ul className="public-home-features">
            <li>
              <strong>Omnichannel inbox</strong>
              <span>
                Centralize customer conversations (including WhatsApp) with clear ownership,
                history, and next steps for your team.
              </span>
            </li>
            <li>
              <strong>CRM &amp; pipeline</strong>
              <span>
                Keep contacts and opportunities updated from real conversations — without
                duplicating work across tools.
              </span>
            </li>
            <li>
              <strong>Scheduling &amp; follow-up</strong>
              <span>
                Plan outreach, reminders, and returns so nothing important falls through the cracks.
              </span>
            </li>
            <li>
              <strong>AI assistants</strong>
              <span>
                Use digital employees to qualify leads, answer FAQs, and support your team within
                the rules you configure.
              </span>
            </li>
          </ul>
        </section>

        <section className="public-home-section" aria-labelledby="google-access">
          <h2 id="google-access">Google account access</h2>
          <p>
            Some Mends features let you connect a Google account (for example Gmail) so the
            platform can send and manage email on your behalf. We only request access needed for
            those features. You can disconnect Google access at any time from your account
            settings. See our{' '}
            <Link to="/privacy">Privacy Policy</Link> for details on how we collect, use, and
            protect data.
          </p>
        </section>

        <section className="public-home-section" aria-labelledby="legal-links">
          <h2 id="legal-links">Legal</h2>
          <p>
            Review our public policies before using the product. These pages do not require a
            login.
          </p>
          <div className="public-home-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/">Sign in</Link>
          </div>
        </section>
      </main>

      <footer className="public-home-footer">
        <div className="public-home-footer-inner">
          <span>© {new Date().getFullYear()} Mends</span>
          <div className="public-home-footer-links">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/">Sign in</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicHomePage;
